@if (!isUiTest) {
  <div>
    <span style="font-weight: bold;">{{ securities.length }} securities</span>
    <irb-inventory-grid id="mmc-advisor-detail-securities-alloc-grid"
      [style.height]="height"
      [showSideBar]='false'
      [gridOptions]="gridOptions"
      [frameworkComponents]="frameworkComponents"
      [componentName]="'MmcAdvisorSecurityAllocationsComponent'"
      (gridReady)="onGridReady($event)">
    </irb-inventory-grid>
  </div>
}
